export const PERMISSIONS = {
  GROUP_CREATE: 'group:create',
  GROUP_READ: 'group:read',
  GROUP_UPDATE: 'group:update',
  GROUP_DELETE: 'group:delete',

  PERMISSION_CREATE: 'permission:create',
  PERMISSION_READ: 'permission:read',
  PERMISSION_UPDATE: 'permission:update',
  PERMISSION_DELETE: 'permission:delete',

  USER_CREATE: 'user:create',
  USER_READ: 'user:read',
  USER_UPDATE: 'user:update',
  USER_DELETE: 'user:delete',

  ROLE_CREATE: 'role:create',
  ROLE_READ: 'role:read',
  ROLE_UPDATE: 'role:update',
  ROLE_DELETE: 'role:delete',

  ORGANIZATION_CREATE: 'organization:create',
  ORGANIZATION_READ: 'organization:read',
  ORGANIZATION_UPDATE: 'organization:update',
  ORGANIZATION_DELETE: 'organization:delete',

  VERSION_CREATE: 'version:create',
  VERSION_WRITE: 'version:write',

  VERIFY_EMAIL: 'user:update_email_verified',
  RESEND_EMAIL: 'user:resend_email_verification',

  CACHE_DELETE: 'cache:delete',
};

export const TABLE_CHANGE_EVENT_OPTIONS = {
  PAGINATION: 'pagination',
  SORT: 'sort',
  FILTER: 'filter',
};

export const offset = 10;

export const DEFAULT_SIZE_PER_PAGE = 100;

export const PAGINATION_OPTIONS = {
  custom: true,
  pageStartIndex: 1,
  paginationSize: 5,
  alwaysShowAllBtns: false,
  withFirstAndLast: true,
  firstPageText: 'First',
  prePageText: 'Previous',
  nextPageText: 'Next',
  lastPageText: 'Last',
  nextPageTitle: 'First page',
  prePageTitle: 'Pre page',
  firstPageTitle: 'Next page',
  lastPageTitle: 'Last page',
  sizePerPageList: [
    {
      text: '10',
      value: 10,
    },
    {
      text: '25',
      value: 25,
    },
    {
      text: '50',
      value: 50,
    },
    {
      text: '100',
      value: 100,
    },
  ],
};

export const MAX_PAGE_SIZE = 100;

export const ROLES_SEARCH_FIELDS = ['applicationType', 'description', 'name'];

export const USERS_SEARCH_FIELDS = [
  'email',
  'givenName',
  'familyName',
  'name',
  'nickname',
];
export const ORGANIZATION_MEMBERS_SEARCH_FIELDS = [
  'email',
  'givenName',
  'familyName',
];

export const ORGANIZATION_SEARCH_FIELDS = ['name', 'description', 'website'];

export const CONNECTED_ORGANIZATION_SEARCH_FIELDS = ['name', 'description'];

export const GROUPS_SEARCH_FIELDS = ['name', 'description'];

export const PERMISSIONS_SEARCH_FIELDS = [
  'name',
  'description',
  'applicationId',
];

export const DEFAULT_LANGUAGE = {
  value: 'en',
  label: 'English',
};

export const ADD_MODAL_TYPES = {
  USERS: 'USERS',
  GROUPS: 'GROUPS',
  ROLES: 'ROLES',
};

export const AUTH0_ID_PREFIX = 'auth0|';

export const INVALID_COLOR = 'red';

export const IDEM_ACCENT_ORANGE = '#1441F5';

export const SUBSCRIPTION_TYPE = {
  DEMO: 1,
  PRO: 2,
};

export const SORT_ORGANIZATIONS = 'name_asc';
export const SORT_USERS = 'created_at_desc';
export const SORT_PERMISSIONS = 'name_asc';

export const REGEX = {
  VERSION: new RegExp(/^\d+\.\d+\.\d+$/),
  POSTAL_CODE: new RegExp(/^[A-Za-z0-9][A-Za-z0-9\- ]{0,10}[A-Za-z0-9]$/),
  PERMISSION_VALIDATION: new RegExp(
    /^[a-zA-Z]+[\w-]*[a-zA-Z0-9]*:[a-zA-Z]+[\w-]*[a-zA-Z0-9]*$/
  ),
  // eslint-disable-next-line no-useless-escape
  PHONE: new RegExp(/^\+?[0-9\s\-\.]{7,15}$/),
};

export const BACKEND_ERRORS = {
  VALIDATION_ERROR: 'Validation error',
};

export const TABLE_IDS = {
  ORGANIZATIONS: 'ORGANIZATIONS',
  ORGANIZATION_MEMBERS: 'ORGANIZATION_MEMBERS',
  ORGANIZATION_ADMINS: 'ORGANIZATION_ADMINS',
  GROUPS: 'GROUPS',
  INVITATIONS: 'INVITATIONS',
  GROUP_MEMBERS: 'GROUP_MEMBERS',
  GROUP_ADMINS: 'GROUP_ADMINS',
  USERS: 'USERS',
  ROLES: 'ROLES',
  PERMISSIONS: 'PERMISSIONS',
  CONNECTED_ORGANIZATIONS: 'CONNECTED_ORGANIZATIONS',
};

export const MAX_NUMBER_OF_CHARACTERS = {
  DESCRIPTION: 255,
  GROUP_NAME: 50,
  VERSION: 8,
};

export const ORGANIZATION_TYPE = {
  CUSTOMER: 'Customer',
  RECON_CENTER: 'ReconCenter',
  SALES: 'Sales',
  LEGAL: 'Legal',
  LEGAL_DIVISION: 'LegalDivision',
};

export const DEFAULT_TYPE_VALUE = ORGANIZATION_TYPE.CUSTOMER;

export const DEFAULT_BRAND_VALUE = 'Bridge';

export const CONNECTED_ORG_LABELS = {
  [ORGANIZATION_TYPE.CUSTOMER]: 'customers',
  [ORGANIZATION_TYPE.RECON_CENTER]: 'reconCenters',
  [ORGANIZATION_TYPE.SALES]: 'sales',
  [ORGANIZATION_TYPE.LEGAL]: 'legals',
  [ORGANIZATION_TYPE.LEGAL_DIVISION]: 'legalDivisions',
};

export const ORGANIZATION_TYPE_OPTIONS = [
  {
    value: ORGANIZATION_TYPE.CUSTOMER,
    label: 'Customer',
    connectedOrganizationLabel:
      CONNECTED_ORG_LABELS[ORGANIZATION_TYPE.CUSTOMER],
    availableForBrandAdmin: true,
  },
  {
    value: ORGANIZATION_TYPE.RECON_CENTER,
    label: 'Reconditioning center',
    connectedOrganizationLabel:
      CONNECTED_ORG_LABELS[ORGANIZATION_TYPE.RECON_CENTER],
    availableForBrandAdmin: false,
  },
  {
    value: ORGANIZATION_TYPE.SALES,
    label: 'Sales',
    connectedOrganizationLabel: CONNECTED_ORG_LABELS[ORGANIZATION_TYPE.SALES],
    availableForBrandAdmin: true,
  },
  {
    value: ORGANIZATION_TYPE.LEGAL,
    label: 'Legal',
    connectedOrganizationLabel: CONNECTED_ORG_LABELS[ORGANIZATION_TYPE.LEGAL],
    availableForBrandAdmin: false,
  },
  {
    value: ORGANIZATION_TYPE.LEGAL_DIVISION,
    label: 'Legal division',
    connectedOrganizationLabel:
      CONNECTED_ORG_LABELS[ORGANIZATION_TYPE.LEGAL_DIVISION],
    availableForBrandAdmin: false,
  },
];

export const USER_TYPE_OPTIONS = ORGANIZATION_TYPE_OPTIONS;

export const ORGANIZATION_TYPE_ABLE_TO_CONNECT = {
  [ORGANIZATION_TYPE.CUSTOMER]: [
    ORGANIZATION_TYPE.RECON_CENTER,
    ORGANIZATION_TYPE.SALES,
  ],
  [ORGANIZATION_TYPE.RECON_CENTER]: [
    ORGANIZATION_TYPE.CUSTOMER,
    ORGANIZATION_TYPE.SALES,
  ],
  [ORGANIZATION_TYPE.SALES]: [
    ORGANIZATION_TYPE.CUSTOMER,
    ORGANIZATION_TYPE.RECON_CENTER,
  ],
  [ORGANIZATION_TYPE.LEGAL_DIVISION]: [],
  [ORGANIZATION_TYPE.LEGAL]: [],
};

export const TYPES_OF_VERSION = [
  { label: 'Minimum required version', name: 'minRequiredVersion' },
  { label: 'Current version', name: 'currentVersion' },
];

// only used in this format, if needed change to usual form
export const PLATFORMS = {
  'ios/webapp': 'iOS / Web application',
};

export const ERROR_MESSAGES = {
  CASE_NOT_HANDLED: 'Error! Case not handled!',
};

export const DELIVERY_ADDRESS_TYPES = {
  BILLING: 'Billing',
  DELIVERY: 'Delivery',
};
